import React from 'react';
import { Fade } from '@material-ui/core';
import { isSuccessState } from 'globals/utils';
import reportLocales from 'globals/locales/report';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { useReportContext } from 'contexts/report/ReportContext';
import { observer } from 'mobx-react';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import {
  Caption,
  DataCol,
  Value,
  WrapperBox,
} from './BusinessData.style-elements';

// Locales
const {
  businessData: { title, captions },
} = reportLocales;

const BusinessData: React.FC = () => {
  const {
    report: {
      basicInfo: { status },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );

  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper title={title} data-test="business-data-component">
        <FsMinWidthScrollBox breakpointDown="sm">
          <WrapperBox>
            <DataCol>
              <Caption>{captions.tradingAddresses}</Caption>
              <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
              <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
            </DataCol>
            <DataCol>
              <Caption>{captions.registeredAddress}</Caption>
              <Value>52 Brook Street 1st Floor, Mayfair London W1K 5DS</Value>
            </DataCol>
            <DataCol isLast>
              <Caption>{captions.companyHouseRegNumber}</Caption>
              <Value>5555555</Value>
              <Caption>{captions.vatRegNumber}</Caption>
              <Value>55555555</Value>
            </DataCol>
          </WrapperBox>
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(BusinessData);
